import script from "./QueryBeachesView.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryBeachesView.vue?vue&type=script&setup=true&lang=js"

import "./QueryBeachesView.vue?vue&type=style&index=0&id=ef7ca7fa&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef7ca7fa"]])

export default __exports__